<template>
  <div class="page-wrapper">
    <div class="view"></div>
    <van-nav-bar
        title="预约挂号"
        left-arrow
        @click-left="onBack"
        fixed
        placeholder
    />
    <div class="container-item">
      <div class="info-box van-hairline--bottom">
        <div class="label">
          <span class="red">*</span>
          <span>预约就诊人</span>
        </div>
        <div class="value">
          {{ patientInfo.name || "-" }}
          {{
            `${{1: "男", 0: "女"}[patientInfo.sex] || "未知"} ${
                patientInfo.age || "-"
            }岁`
                }}
        </div>
      </div>
      <div class="info-box van-hairline--bottom">
        <div class="label">
          <span class="red">*</span>
          <span>联系电话</span>
        </div>
        <div class="value">{{ formatPhoneComputed || "-" }}</div>
      </div>
      <div class="info-box van-hairline--bottom">
        <div class="label">
          <span class="red">*</span>
          <span>本次问诊是否为复诊</span>
        </div>
        <div class="value">
          <van-radio-group v-model="form.isOfflineVisit" :icon-size="16">
            <van-radio
                :name="item.value"
                v-for="(item, index) in firstVisits.list"
                :key="index"
            >{{ item.label }}
            </van-radio
            >
          </van-radio-group>
        </div>
      </div>
      <template v-if="form.isOfflineVisit === 1">
        <div class="info-box van-hairline--bottom">
          <div class="label">
            <span class="red">*</span>
            <span>首次问诊的医院</span>
          </div>
          <div class="value">
            <van-field
                v-model.trim="form.hospitalName"
                placeholder="请填写医院/诊所名称"
                input-align="right"
                :maxlength="20"
            />
          </div>
        </div>
        <div class="info-box full">
          <div class="label">
            <span class="red">*</span>
            <span>线下首诊时医生的诊断</span>
          </div>
          <div class="value">
            <van-field
                v-model.trim="form.hospitalDiagnose"
                placeholder="请描述首诊时线下医生对你的疾病诊断情况"
                :maxlength="20"
                show-word-limit
            />
          </div>
        </div>
        <div class="info-box">
          <div class="label">预约选择</div>
          <div class="value">
            <van-radio-group
                v-model="types.active"
                :icon-size="16"
                @change="onTypesChange"
            >
              <van-radio
                  :name="item.value"
                  v-for="(item, index) in types.list"
                  :key="index"
              >{{ item.label }}
              </van-radio
              >
            </van-radio-group>
          </div>
        </div>
      </template>
    </div>
    <div class="selectors" v-if="form.isOfflineVisit === 1">
      <div class="dates" v-if="types.active === 'normal'">
        <div
            class="item"
            v-for="(item, index) in dateListComputed"
            :key="index"
            @click="onDateChange(item)"
        >
          <div
              class="item-box"
              :class="form.selectDay === item.value ? 'active' : ''"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="scrollbar" ref="doctorsRef">
        <div class="doctors">
          <div
              class="item"
              :class="{ active: form.doctorNo === item.staffNo }"
              v-for="(item, index) in doctorSchedulingList"
              :key="index"
          >
            <div class="info">
              <div class="avatar">
                <van-image :src="item.photo" fit="cover"/>
              </div>
              <div class="text">
                <div class="title">
                  <span>{{ item.staffName }}</span>
                  <span>-</span>
                  <span>{{ item.clinicalTitleName }}</span>
                </div>
                <div class="desc" v-if="item.intro">
                  <TextEllipsis :text="item.intro"/>
                </div>
              </div>
              <div class="sign" v-if="$route.query.doctorNo === item.staffNo">
                专属
              </div>
            </div>
            <div class="methods">
              <div
                  class="itm"
                  :class="{
                  active:
                    itm.value === form.askType &&
                    item.staffNo === form.doctorNo,
                }"
                  v-for="(itm, idx) in methods"
                  :key="idx"
                  @click="onMethodChange(item, itm)"
              >
                <div class="icon">
                  <svg
                      t="1720074922106"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5212"
                      width="200"
                      height="200"
                      v-if="itm.value === AskMethodType.VIDEO"
                  >
                    <path
                        d="M691.003077 414.404923c0 2.717538-2.875077 7.483077-8.546462 14.296615a359.581538 359.581538 0 0 0-18.432 24.103385 270.848 270.848 0 0 0-18.392615 30.247385c-5.750154 10.909538-8.546462 22.055385-8.546462 33.516307 0 11.421538 2.835692 22.449231 8.546462 33.083077a229.651692 229.651692 0 0 0 36.824615 50.727385c5.671385 5.710769 8.546462 9.373538 8.546462 11.027692v85.819077c0 9.255385-3.387077 19.731692-10.24 31.468308a168.290462 168.290462 0 0 1-25.324308 33.083077c-10.043077 10.358154-21.267692 18.983385-33.516307 25.757538-12.209231 6.813538-23.827692 10.24-34.737231 10.24H180.932923a100.785231 100.785231 0 0 1-72.743385-29.420307 99.406769 99.406769 0 0 1-21.661538-32.689231A106.102154 106.102154 0 0 1 78.769231 694.744615V342.449231c0-10.870154 2.481231-22.212923 7.364923-33.910154 4.923077-11.697231 11.815385-22.449231 20.834461-32.295385 9.019077-9.806769 19.613538-17.959385 31.901539-24.49723a84.676923 84.676923 0 0 1 40.448-9.846154h406.252308c14.690462 0 28.475077 2.599385 41.275076 7.798154a106.338462 106.338462 0 0 1 33.476924 21.267692 99.328 99.328 0 0 1 30.680615 72.349538v71.089231zM945.230769 337.526154v373.563077c0 11.972923-3.150769 22.606769-9.412923 31.901538-6.262154 9.255385-15.675077 13.863385-28.199384 13.863385-4.332308 0-9.924923-1.654154-16.777847-4.923077a187.470769 187.470769 0 0 1-20.40123-11.421539 371.712 371.712 0 0 1-19.219693-13.075692 120.910769 120.910769 0 0 1-13.075692-10.633846c-7.089231-5.986462-17.880615-16.344615-32.295385-31.074462a637.755077 637.755077 0 0 1-43.716923-49.860923c-14.729846-18.510769-27.648-37.572923-38.83323-57.225846-11.185231-19.613538-16.738462-37.572923-16.738462-53.956923 0-16.305231 5.986462-34.973538 17.959385-55.926154 12.012308-21.031385 26.427077-41.590154 43.323077-61.755077 16.896-20.164923 34.658462-38.833231 53.129846-56.004923 18.510769-17.171692 34.067692-30.089846 46.631384-38.793846 4.883692-3.268923 11.539692-7.246769 19.968-11.854769 8.467692-4.647385 15.950769-6.971077 22.528-6.971077 14.690462 0 24.221538 4.096 28.593231 12.248615 4.332308 8.192 6.537846 18.274462 6.537846 30.247385v1.654154z"
                        p-id="5213"
                    ></path>
                  </svg>
                  <svg
                      t="1720074869244"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5051"
                      width="200"
                      height="200"
                      v-else
                  >
                    <path
                        d="M398.652952 165.692952c-32.280381-46.006857-58.172952-61.318095-92.867047-54.808381-14.969905 2.80381-24.210286 7.850667-41.20381 22.528l-12.946285 11.361524-25.185524 20.894476-6.582857 5.753905c-3.705905 3.413333-6.38781 6.217143-9.825524 10.118095-64 72.46019-81.724952 185.782857-44.470857 292.327619 26.794667 76.55619 74.605714 152.624762 142.774857 228.644572 72.289524 80.62781 133.046857 131.364571 202.922666 168.374857 54.857143 29.013333 96.865524 41.74019 145.676191 43.227429 59.001905 1.828571 110.957714-11.50781 153.648762-39.15581a162.133333 162.133333 0 0 0 19.553524-15.189333l8.289523-7.558095 16.335239-15.213715 5.534476-4.924952 10.922666-9.435429c22.040381-19.651048 29.184-31.939048 30.646858-51.370666 2.194286-29.647238-11.215238-52.736-49.737143-85.699048l-26.063238-21.820952-12.117334-10.581334-11.459047-9.825524c-37.229714-30.744381-64.804571-40.69181-100.205715-35.35238-24.283429 3.632762-38.278095 12.141714-63.073523 38.107428l-10.947048 11.654095c-18.041905 19.017143-28.330667 26.258286-43.544381 29.305905-22.25981 4.461714-44.373333-7.046095-80.262095-36.205714-46.250667-37.546667-84.626286-80.676571-117.613715-131.949714-22.869333-35.766857-31.890286-62.902857-24.941714-87.600762 2.82819-9.99619 9.679238-17.042286 24.064-28.184381l14.994286-11.312762 2.413714-1.877334 22.747429-18.553904c20.114286-16.822857 28.281905-28.281905 32.572952-45.836191 8.899048-36.10819 0.487619-66.072381-32.426667-117.638095l-15.62819-24.234667-5.558857-8.533333-6.436572-9.435429z"
                        p-id="5052"
                    ></path>
                  </svg>
                </div>
                <div class="text">
                  <div class="name">{{ itm.label }}</div>
                  <div class="price">
                    <span>￥</span>
                    <span>{{ item[itm.prop] || 0 }}</span>
                  </div>
                </div>
                <div class="btn_qwz">去问诊</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="selected" v-if="form.doctorNo && form.apptStartTime">
        <div class="content" @click="onTimeConfirm">
          <span>已选择：</span>
          <span>服务医生【</span>
          <span>{{
              doctorCurrentComputed.staffName || echoInfo.doctorName
            }}</span>
          <span>】于</span>
          <span>
            {{ formatTime(form.apptStartTime).format("YYYY年MM月DD日") }}
          </span>
          <span>
            &nbsp;{{
              ["周日", "周一", "周二", "周三", "周四", "周五", "周六"][
                  formatTime(form.apptStartTime).get("weekday")
                  ]
            }}&nbsp;
          </span>
          <span>{{ formatTime(form.apptStartTime).format("HH:mm") }}</span>
          <span>-</span>
          <span>{{ formatTime(form.apptEndTime).format("HH:mm") }}</span>
          <span>进行</span>
          <span>
            {{ askMethodTypes.findValue({value: form.askType}) }}
          </span>
        </div>
      </div>
    </div>
    <div class="warn" v-else>
      <div class="tip">
        您没有在线下实体医疗机构问诊过，本次问诊为首诊。根据《互联网医院管理办法》规定。互联网医院不得为首诊患者提供诊疗服务，患者应当在实体医疗机构进行首次就诊。
      </div>
    </div>

    <!-- 时段选择 -->
    <ReservationTimes
        :appt-start-time.sync="form.apptStartTime"
        :appt-end-time.sync="form.apptEndTime"
        :appt-self="onTimeAppSelf"
        :interval="newUserComputed ? 30 : 15"
        ref="ReservationTimesRef"
        @confirm="onTimeConfirm"
    />

    <van-popup v-model="confirms.show" title="挂号信息确认" position="right">
      <div class="confirms">
        <div class="scrollbar">
          <div class="content">
            <div class="item">
              <div class="label">预约就诊人</div>
              <div class="value">{{ patientInfo.name }}</div>
            </div>
            <div class="item">
              <div class="label">预约电话</div>
              <div class="value">{{ formatPhoneComputed || "-" }}</div>
            </div>
            <div class="item">
              <div class="label">本次问诊是否为复诊</div>
              <div class="value">
                {{
                  (
                      firstVisits.list.find(
                          (row) => row.value === form.isOfflineVisit
                      ) || {}
                  ).label
                }}
              </div>
            </div>
            <div class="item">
              <div class="label">首次问诊的医院</div>
              <div class="value">{{ form.hospitalName }}</div>
            </div>
            <div class="item">
              <div class="label">线下首诊时医生的诊断</div>
              <div class="value">{{ form.hospitalDiagnose }}</div>
            </div>
            <div class="item">
              <div class="label">预约时间</div>
              <div class="value">
                <template v-if="types.active === 'quick'">
                  <span>{{
                      formatTime(form.selectDay).format("YYYY年MM月DD日")
                    }}</span>
                </template>
                <template v-else>
                  <span>{{
                      formatTime(form.apptStartTime).format(
                          "YYYY年MM月DD日 HH:mm"
                      )
                    }}</span>
                  <span>-</span>
                  <span>{{
                      formatTime(form.apptEndTime).format("HH:mm")
                    }}</span>
                </template>
              </div>
            </div>
            <div class="item">
              <div class="label">预约医生</div>
              <div class="value">
                <div class="doctor">
                  <div class="avatar">
                    <van-image :src="confirms.doctor.avatar" fit="cover"/>
                  </div>
                  <div class="text">
                    <span>{{ confirms.doctor.name }}</span>
                    <span>-</span>
                    <span>{{ confirms.doctor.title }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="label">问诊方式</div>
              <div class="value">
                {{ askMethodTypes.findValue({value: form.askType}) }}
              </div>
            </div>
            <div class="item">
              <div class="label">预约挂号费</div>
              <div class="value">
                <span>￥</span>
                <span>{{ echoInfo.doctorPrice }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="foot">
          <van-button class="button" @click="confirms.show = false"
          >返回
          </van-button
          >
          <van-button class="button" :loading="loading" @click="onSaveForm"
          >提交预约
          </van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {formatTime} from "@/hooks/function";
import {askMethodTypes} from "@/hooks/useAsk";
import {AskMethodType} from "@/hooks/useAsk/type";
import {getPatientDetails} from "@/api/index";
import {
  getWorkStaffByDate,
  saveSubscribe,
  editSubscribe,
  getSubscribeInfo,
} from "@/api/subscribe";
import ReservationTimes from "@/components/reservation/times.vue";
import TextEllipsis from "@/components/text/ellipsis/index.vue";
import {getStaffSchedule, getStudios} from "@/api/home";

export default {
  name: "Reservation",
  components: {
    ReservationTimes,
    TextEllipsis,
  },
  data() {
    return {
      askMethodTypes,
      AskMethodType,
      form: {
        askType: "",
        selectDay: "",
        doctorNo: "",
        apptStartTime: "", // 开始 时间
        apptEndTime: "", //  结束 时间
        isOfflineVisit: 1,
        hospitalName: "",
        hospitalDiagnose: "",
      },
      patientInfo: {},
      echoInfo: {
        doctorNo: "",
        apptStartTime: "", // 开始 时间
        apptEndTime: "", //  结束 时间
        doctorName: "",
        doctorAvatar: "",
        doctorTitle: "",
        doctorPrice: 0,
      },
      doctorSchedulingList: [],
      loading: false,
      times: {
        show: false,
        list: [],
        appointed: {
          memberId: "",
          doctorNo: "",
          startTime: "",
          endTime: "",
        },
      },
      confirms: {
        show: false,
        doctor: {
          name: "",
          avatar: "",
          title: "",
        },
      },
      types: {
        active: "normal",
        list: [
          {
            label: "常规预约",
            value: "normal",
          },
          {
            label: "快速预约",
            value: "quick",
          },
        ],
      },
      firstVisits: {
        list: [
          {
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },
        ],
      },
      methods: [
        // {
        //   label: askMethodTypes.findValue({ value: AskMethodType.PHONE }),
        //   value: AskMethodType.PHONE,
        //   prop: "phoneAskPrice",
        // },
        {
          label: askMethodTypes.findValue({value: AskMethodType.VIDEO}),
          value: AskMethodType.VIDEO,
          prop: "audioAskPrice",
        },
      ],
      scheduleInfo: {},
      channelCode:[]
    };
  },
  methods: {
    // 获取会诊管理列表
    async getScheduleParams() {
      this.month = formatTime(new Date()).format("YYYY-MM");
      let scheduleParams = {
        date: formatTime(this.month).format("YYYY-MM-01"),
        staffNo: this.$store.state.assistantNo,
      };
      let {data: scheduleInfo} = await getStaffSchedule(scheduleParams);
      this.scheduleInfo = scheduleInfo;
    },
    // 获取工作室列表
    getChannelsList() {
      console.log(this.scheduleInfo);
      let params = {
        ids: this.scheduleInfo.channelId,
      };
      return getStudios(params).then((res) => {
        this.studiosList = res.data;
        this.channelCode = this.studiosList.map((item) => {
          return item.channelCode;
        })
      });
    },

    formatTime,
    async getDoctorSchedulingList(date) {
      try {
        const {data} = await getWorkStaffByDate({
          date,
          type: 1,
          source: 3,
          channelCode: this.channelCode.toString(),
        });
        const list = [];
        data.forEach((item) => {
          if (item.staffNo === this.$route.query.doctorNo) {
            list.unshift({
              ...item,
            });
          } else {
            list.push(item);
          }
        });
        this.doctorSchedulingList = list.filter(
            (row) => formatTime(row.workEndTime).getTime() > Date.now()
        );
      } catch (error) {
      }
    },
    // 获取患者信息
    async getPatientInformation() {
      const {userMemberId} = this.$route.query;
      const {data} = await getPatientDetails({id: userMemberId});
      this.patientInfo = data;
    },
    // 回显
    async getPageSubscribeInfo() {
      const {
        data: {askInfoDoctor},
      } = await getSubscribeInfo({askNo: this.$route.query.askNo});
      const {
        askType,
        doctorNo,
        apptStartTime,
        apptEndTime,
        doctorName,
        photo,
        clinicalTitle,
        askServicePrice,
      } = askInfoDoctor;
      const selectDay = this.formatTime(apptStartTime).format("YYYY-MM-DD");
      this.form = {
        askType,
        doctorNo,
        apptStartTime,
        apptEndTime,
        selectDay,
      };
      this.echoInfo = {
        doctorNo,
        apptStartTime,
        apptEndTime,
        doctorName,
        doctorAvatar: photo,
        doctorTitle: clinicalTitle,
        doctorPrice: askServicePrice,
      };
      await this.getDoctorSchedulingList(selectDay);
      this.times.appointed.memberId = this.$route.query.userMemberId;
      this.times.appointed.doctorNo = doctorNo;
      this.times.appointed.startTime = apptStartTime;
      this.times.appointed.endTime = apptEndTime;
      this.$nextTick(() => {
        if (this.$refs.doctorsRef) {
          const selector = this.$refs.doctorsRef.querySelector(".item.active");
          selector && selector.scrollIntoView();
        }
      });
    },
    async onDateChange(item) {
      if (this.form.selectDay === item.value) return;
      this.form.selectDay = item.value;
      this.form.doctorNo = "";
      this.form.apptStartTime = "";
      this.form.apptEndTime = "";
      try {
        await this.getDoctorSchedulingList(item.value);
        // this.$nextTick(() => {
        //   if (this.$refs.doctorsRef) {
        //     const selector = this.$refs.doctorsRef.querySelector(".item:first-child");
        //     selector && selector.scrollIntoView();
        //   }
        // });
      } catch (error) {
      }
    },
    async onSaveForm() {
      if (this.loading) return false;
      // if (!this.form.askType) return this.$toast("请选择问诊方式");
      // if (!this.form.selectDay) return this.$toast("请选择预约时间");
      // if (!this.form.doctorNo) return this.$toast("请选择预约医生");
      // if (!this.form.apptStartTime || !this.form.apptEndTime)
      //   return this.$toast("请选择预约时间段");
      this.loading = true;
      try {
        // 修改
        if (this.$route.query.askNo) {
          await editSubscribe({
            ...this.form,
            isAppt: true,
            memberId: this.$route.query.userMemberId,
            doctorAssistantNo: this.$store.state.assistantNo,
            askNo: this.$route.query.askNo,
          });
          this.loading = false;
          this.$toast(`修改预约成功`);
          this.$router.back();
        } else {
          const {data} = await saveSubscribe({
            ...this.form,
            isAppt: true,
            memberId: this.$route.query.userMemberId,
            doctorAssistantNo: this.$store.state.assistantNo,
            apptStartTime: this.form.apptStartTime || null,
            apptEndTime: this.form.apptEndTime || null,
            isAppt: this.types.active === "quick" ? 0 : 1,
          });
          this.loading = false;
          this.$toast(`预约成功`);
          // this.qrcodes.url = data.askNo
          this.$router.replace(`/reservation/pay?askNo=${data.askNo}`);
        }
      } catch (error) {
        this.loading = false;
      }
    },
    onBack() {
      this.$router.back();
    },
    async onFormValid() {
      if (!this.form.hospitalName) {
        this.$toast("请填写首次问诊的医院");
        throw false;
      } else if (!this.form.hospitalDiagnose) {
        this.$toast("请填写线下首诊时医生的诊断");
        throw false;
      }
    },
    async onMethodChange(doctor, method) {
      try {
        await this.onFormValid();
        this.echoInfo.doctorPrice = doctor[method.prop] || 0;
        if (this.form.doctorNo !== doctor.staffNo) {
          this.form.apptStartTime = "";
          this.form.apptEndTime = "";
        }
        this.form.doctorNo = doctor.staffNo;
        this.form.askType = method.value;
        if (this.types.active === "quick") {
          this.onTimeConfirm();
        } else {
          this.$refs.ReservationTimesRef &&
          this.$refs.ReservationTimesRef.onTimeInit(
              doctor,
              this.form.selectDay
          );
        }
      } catch (error) {
      }
    },
    onTimeAppSelf(startTime, endTime) {
      if (this.$refs.ReservationTimesRef) {
        return (
            this.times.appointed.memberId === this.$route.query.userMemberId &&
            this.times.appointed.doctorNo === this.form.doctorNo &&
            this.$refs.ReservationTimesRef.onTimeInRange(
                startTime,
                endTime,
                this.times.appointed.startTime,
                this.times.appointed.endTime
            )
        );
      }
      return false;
    },
    async onTimeConfirm() {
      try {
        await this.onFormValid();
        if (this.doctorCurrentComputed.staffNo) {
          this.confirms.doctor = {
            name: this.doctorCurrentComputed.staffName,
            avatar: this.doctorCurrentComputed.photo,
            title: this.doctorCurrentComputed.clinicalTitleName,
          };
        } else {
          this.confirms.doctor = {
            name: this.echoInfo.doctorName,
            avatar: this.echoInfo.doctorAvatar,
            title: this.echoInfo.doctorTitle,
          };
        }
        this.confirms.show = true;
      } catch (error) {
      }
    },
    onTypesChange() {
      if (this.types.active === "quick") {
        this.form.doctorNo = "";
        this.form.apptStartTime = "";
        this.form.apptEndTime = "";
        if (this.form.selectDay !== this.dateListComputed[0].value) {
          this.onDateChange(this.dateListComputed[0]);
        }
      }
    },
  },
  computed: {
    // 是否是新用户
    newUserComputed() {
      return !this.patientInfo.prescriptionQuantity;
    },
    // 手机格式化
    formatPhoneComputed() {
      if (!this.patientInfo.mobile) return "";
      const part1 = String(this.patientInfo.mobile).substring(0, 3);
      const part2 = String(this.patientInfo.mobile).substring(3, 7);
      const part3 = String(this.patientInfo.mobile).substring(7);
      return `${part1}  ${part2}  ${part3}`;
    },
    // 日期列表
    dateListComputed() {
      const recentThreeDays = [];
      const currentDate = new Date();
      for (let i = 0; i < 5; i++) {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const day = currentDate.getDate();
        const recentDate = new Date(year, month, day + i);
        recentThreeDays.push({
          label: formatTime(recentDate).format("MM月DD号"),
          value: formatTime(recentDate).format("YYYY-MM-DD"),
        });
      }
      return recentThreeDays;
    },
    // 当前选中医生信息
    doctorCurrentComputed() {
      if (!this.form.doctorNo) return {};
      const index = this.doctorSchedulingList.findIndex(
          (item) => item.staffNo === this.form.doctorNo
      );
      if (index === -1) return {};
      const doctorInfo = this.doctorSchedulingList[index];
      return doctorInfo;
    },
  },
  watch: {},
  async mounted() {
    try {
      await this.getScheduleParams();
      await this.getChannelsList();
      await this.getPatientInformation();
      if (this.$route.query.askNo) await this.getPageSubscribeInfo();
      else if (this.dateListComputed.length) {
        this.form.selectDay = this.dateListComputed[0].value;
        await this.getDoctorSchedulingList(this.form.selectDay);
      }
    } catch (error) {
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

$radius: 5px;

:deep(.van-nav-bar) {
  .van-nav-bar__left,
  .van-icon {
    font-size: 20px;
    color: #333;
  }
}

.page-wrapper {
  background: #fff;
  height: 100vh;
  // @include flex($dir: column);
  // overflow: hidden;

  .container-item {
    padding: 0 18px;
    background: #fff;

    & + .container-item {
      border-top: 14px solid #f9fafe;
    }

    .info-box {
      display: flex;
      padding: 18px 0;
      justify-content: space-between;

      &.full {
        display: block;

        .van-field {
          border: 1px solid #eee;
          margin-top: 10px;
          padding: 10px;
          border-radius: 4px;
        }
      }

      &:not(.full) {
        .van-field {
          padding: 0;
        }
      }

      .label {
        font-weight: bold;
        color: #333333;
        font-size: 18px;

        .red {
          color: #f00;
        }
      }

      .value {
        font-weight: normal;
        font-size: 20px;

        .van-radio-group {
          @include flex(center);
          font-size: 18px;

          .van-radio {
            &:not(:first-child) {
              margin-left: 20px;
            }

            :deep(.van-radio__icon) {
              height: auto;

              .van-icon {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }

  .selectors {
    flex: 1;
    background: #f9fafe;
    padding: 15px;
    @include flex($dir: column);
    overflow: hidden;

    .dates {
      @include flex();
      margin-left: -10px;

      .item {
        width: calc(100% / 5);
        font-size: 16px;

        &-box {
          height: 40px;
          background: #fff;
          @include flex(center, center);
          border: 1px solid #f3f3f3;
          border-radius: 5px;
          flex: none;
          margin-left: 10px;
          cursor: pointer;

          &.active {
            border-color: $color-primary;
            color: $color-primary;
            font-weight: bold;
          }
        }
      }
    }

    .scrollbar {
      flex: 1;
      overflow-y: auto;
      margin-top: 10px;

      .doctors {
        .item {
          background: #fff;
          padding: 12px;
          border-radius: $radius;

          &:not(:first-child) {
            margin-top: 12px;
          }

          .info {
            position: relative;
            @include flex();

            .avatar {
              flex: none;
              width: 40px;
              height: 40px;
              border-radius: $radius;
              overflow: hidden;

              .van-image {
                width: 100%;
                height: 100%;
              }
            }

            .text {
              margin-left: 10px;

              .title {
                font-weight: bold;
                color: #333;
                font-size: 16px;
              }
            }

            .desc {
              font-size: 14px;
              margin-top: 5px;
              color: #999;
              word-break: break-all;
            }

            .sign {
              position: absolute;
              right: 0;
              top: 0;
              background: rgba($color-primary, 0.1);
              color: $color-primary;
              font-size: 14px;
              padding: 2px 10px;
              border-radius: 5px;
            }
          }

          .methods {
            @include flex(center, flex-end);
            margin-top: 25px;

            .itm {
              border-radius: $radius;
              padding: 8px;
              min-width: 110px;
              color: #666;
              border: 1px solid #ccc;
              width: 85%;
              cursor: pointer;
              @include flex();

              &:not(:first-child) {
                margin-left: 10px;
              }

              &:active {
                opacity: 0.85;
              }

              .icon {
                width: 30px;
                height: 30px;
                background-size: 100% 100%;
                background-repeat: no-repeat;

                svg {
                  fill: #999;
                }
              }

              .text {
                margin-left: 6px;

                .name {
                  font-size: 14px;
                }

                .price {
                  font-size: 16px;
                  margin-top: 5px;
                }
              }

              .btn_qwz {
                display: flex;
                align-items: center;
                line-height: 1;
                font-size: 14px;
                margin-left: 160px;
                color: #fff;
                background: #4d86f7;
                border-radius: 30px;
                padding: 5px 20px;
                box-sizing: border-box;
              }

              &.active {
                color: $color-primary;
                border-color: $color-primary;

                .text {
                  .name {
                    font-weight: bold;
                  }
                }

                .icon {
                  svg {
                    fill: #5961f9;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.warn {
  flex: 1;

  .tip {
    margin: 15px;
    padding: 10px;
    border: 1px solid #fac2c1;
    color: #f53731;
    background: #fef5f5;
    font-weight: bold;
    border-radius: 4px;
  }
}

.selected {
  padding: 15px 0;
  cursor: pointer;

  .content {
    border: 1px solid $color-primary;
    color: $color-primary;
    padding: 10px;
    border-radius: $radius;
    background: #fff;
  }
}

.confirms {
  width: 100vw;
  height: 100vh;
  @include flex($dir: column);

  .scrollbar {
    flex: 1;
    overflow-y: auto;

    .content {
      padding: 0 20px;
      font-size: 18px;

      .item {
        @include flex(center, space-between);
        padding: 15px 0;
        border-bottom: 1px solid #eee;

        .label {
          color: #666;
        }

        .value {
          font-weight: bold;

          .doctor {
            @include flex(center);

            .avatar {
              width: 24px;
              height: 24px;
              border-radius: 25px;
              overflow: hidden;

              .van-image {
                width: 100%;
                height: 100%;
              }
            }

            .text {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }

  .foot {
    @include flex(center, center);
    padding: 10px 15px;

    .button {
      font-size: 16px;
      border-radius: 25px;
      height: 48px;

      &::after {
        display: none;
      }

      &:first-child {
        background: #f2f2f2;
        width: 30%;
      }

      &:not(:first-child) {
        background: $color-primary;
        color: #fff;
        flex: 1;
        margin-left: 15px;
      }

      &.hover {
        opacity: 0.85;
      }
    }
  }
}
</style>
